import { render, staticRenderFns } from "./FormWizard.vue?vue&type=template&id=d26f64ce&scoped=true&"
import script from "./FormWizard.vue?vue&type=script&lang=ts&"
export * from "./FormWizard.vue?vue&type=script&lang=ts&"
import style0 from "./FormWizard.vue?vue&type=style&index=0&id=d26f64ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d26f64ce",
  null
  
)

export default component.exports